import React, { useRef, useEffect, useState } from 'react';
import { Box, Container, Select, FormControl, InputLabel, MenuItem, Button, Divider} from '@mui/material';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';
import PageHeader from '../common/banner/pageHeader';
import svgPanZoom from 'svg-pan-zoom'
import { ReactComponent as SVG } from './net.svg'
import { useNavigate } from 'react-router-dom';

export default function NeTERS() {
  const navigate = useNavigate();
  const [host, setHost] = useState("");
  const [macAddress, setMACAddress] = useState("");
  const [ipv4, setIPv4] = useState("");
  const svgRef = useRef(null);

  useEffect(() => {
    if(!svgRef.current) return;
    const panZoom = svgPanZoom(svgRef.current, {
      zoomEnabled: true,
      controlIconsEnabled: true,
      fit: true,
      center: true,
    });
    return () => {
      panZoom.current?.destroy();
      panZoom.current = null;
    }
  }, []);

  const handleMACAddressChange = (event) => {
    setMACAddress(event.target.value);
    setHost(event.target.value);
  };

  const handleMACAddressSearch = (() => {
    console.log(macAddress);
    console.log(host)
    console.log(ipv4)
    navigate('/hostInformation', {state: {host}})
  });

  const handleIPv4Change = (event) => {
    setIPv4(event.target.value);
  };

  const handleIPv4Search = (() => {
    console.log(ipv4)
    navigate('/hostInformation', {state: {ipv4}})
  });

  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="Network Diagram" />
      </Box>
      Filters
      <Box sx={{display:"flex", 
                justifyContent: "center", 
                alignContent: "center", 
                marginBottom: "20px", 
                fontSize: '18px', 
                border: '1px solid grey',
                bgcolor: '#0f0f0f', 
                padding: '15px'}}>
        MAC Address: 
        <FormControl sx={{minWidth:"200px"}}>
          <InputLabel id="mac-select-label" sx={{color: "white"}}></InputLabel>
          <Select 
            id="select-mac-address"
            value={macAddress}
            onChange={handleMACAddressChange}
            labelStyle={{ color: '#ff0000' }}
            sx={{
              marginLeft: '10px',
              height: '25px',
              color: "white",
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '.MuiSvgIcon-root ': {
                fill: "white !important",
              }
            }}
            >
            <MenuItem value={'00:0c:29:43:d6:e9'} >00:0c:29:43:d6:e9</MenuItem>
            <MenuItem value={'00:0c:29:60:4d:60'} >00:0c:29:60:4d:60</MenuItem>
            <MenuItem value={'00:0c:29:78:c3:cd'} >00:0c:29:78:c3:cd</MenuItem>
            <MenuItem value={'00:0c:29:81:77:9b'} >00:0c:29:81:77:9b</MenuItem>
            <MenuItem value={'00:0c:29:7d:72:26'} >00:0c:29:7d:72:26</MenuItem>
            <MenuItem value={'00:0c:29:a0:9b:6b'} >00:0c:29:a0:9b:6b</MenuItem>
          </Select>
        </FormControl>
      
        <Button
          disabled={!macAddress}
          onClick={handleMACAddressSearch}
          sx={{ marginLeft: "10px", 
          marginRight: '15px',
                color: '#FFF', 
                bgcolor: '#606662' , 
                height: '25px', 
                '&:hover': {
                  backgroundColor: '#1f1e1d'
                } }}>
          Search
              </Button> 
        IPv4: 
        <FormControl sx={{minWidth:"140px"}}>
          <InputLabel id="ipv4-select-label" sx={{color: "white"}}></InputLabel>
          <Select 
            id="select-ipv4"
            value={ipv4}
            onChange={handleIPv4Change}
            labelStyle={{ color: '#ff0000' }}
            sx={{
              marginLeft: '10px',
              height: '25px',
              color: "white",
              '.MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(228, 219, 233, 0.25)',
              },
              '.MuiSvgIcon-root ': {
                fill: "white !important",
              }
            }}
            >
            <MenuItem value={'10.1.2.17'} >10.1.2.17</MenuItem>
            <MenuItem value={'10.1.2.189'} >10.1.2.189</MenuItem>
            <MenuItem value={'10.1.2.192'} >10.1.2.192</MenuItem>
            <MenuItem value={'10.1.2.210'} >10.1.2.210</MenuItem>
            <MenuItem value={'10.1.2.229'} >10.1.2.229</MenuItem>
            <MenuItem value={'10.1.2.233'} >10.1.2.233</MenuItem>
{/*
            <MenuItem value={'10.1.2.18'} >10.1.2.18</MenuItem> 
            <MenuItem value={'192.168.1.11'} >192.168.1.11</MenuItem>
            <MenuItem value={'192.168.1.50'} >192.168.1.50</MenuItem>
*/}
          </Select>
        </FormControl>
      
        <Button
          disabled={!ipv4}
          onClick={handleIPv4Search}
          sx={{ marginLeft: "10px", 
                color: '#FFF', 
                bgcolor: '#606662' , 
                height: '25px', 
                '&:hover': {
                  backgroundColor: '#1f1e1d',
                } }}>
          Search
              </Button> 
      </Box>
      Sensor 001
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          border: '1px solid grey',
          bgcolor: '#0f0f0f',
          padding: '15px',
          marginBottom: '-70px'
        }}
      > 
        <Box
          sx={{
            height: '460px',
            width: '1700px',
            marginTop: '20px',
            margin: '0 auto',
            alignItems: 'center'
          }}
        > 
        <SVG 
          width = '100%' 
          height = '100%' 
          ref={svgRef}>
        </SVG>
        </Box>
      </Box>
    </Container>
  );

};
  
